import { useQuery } from '@tanstack/react-query';
import { useAPIErrorHandler } from '../../useAPIErrorHandler';
import { queries } from '../../../../queries';
import { getData } from '../../../../utils/functional/fp';

type UsePolicyDetailsProps = { id?: string; product?: string };

export function usePolicyDetails(props: UsePolicyDetailsProps) {
  const handleAPIError = useAPIErrorHandler();

  return useQuery({
    ...queries.policies.details(props.id as string, props.product as string),
    keepPreviousData: true,
    onError: handleAPIError("Unable to fetch policy's details"),
    select: getData,
    enabled: Boolean(props.id) && Boolean(props.product),
  });
}
